import { render, staticRenderFns } from "./CompanyLogo.vue?vue&type=template&id=23f098ce&scoped=true"
import script from "./CompanyLogo.vue?vue&type=script&lang=js"
export * from "./CompanyLogo.vue?vue&type=script&lang=js"
import style0 from "./CompanyLogo.vue?vue&type=style&index=0&id=23f098ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f098ce",
  null
  
)

export default component.exports